// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".read-more .read-more-text-empty{font-style:italic;color:var(--grey-light)}\n", ""]);
// Exports
module.exports = exports;
